import { LocationQuery } from 'vue-router';
import {
    CALENDAR_ROUTE_NAMES,
    INVENTORY_ROUTES_NAMES,
    LEGACY_ROUTE_NAME,
    ORDER_ROUTES_NAMES,
} from '@/constants';
import { IFRAME_URL } from '@/bootstrap/environment';

export const useManticoreNavigation = () => {
    const modulesWithUrlParams = [ORDER_ROUTES_NAMES.ORDERS, INVENTORY_ROUTES_NAMES.EXPERIENCES, LEGACY_ROUTE_NAME.EVENT_DATE];
    const modulesWithUrlQuery = [LEGACY_ROUTE_NAME.EVENT_RULE, CALENDAR_ROUTE_NAMES.MONTH];

    const getQueryUrn = (query:LocationQuery | undefined) => {
        if (query) {
            return `?${ new URLSearchParams(query as Record<string, string>).toString() }&inIframe`;
        }
        return '?inIframe';
    };

    const getParamUrn = (query:LocationQuery | undefined) => {
        if (query) {
            return `/${ Object.values(query).join('/') }?inIframe`;
        }
        return '?inIframe';
    };

    const getUrlWithFragmentIdentifier = (fragmentIdentifier:string | undefined) => (fragmentIdentifier ? `#${ fragmentIdentifier}` : '');

    const generateSingleQuery = (query:LocationQuery | undefined, queryString :string) => {
        if (query?.[queryString]) {
            return `${query[queryString]}&inIframe`;
        }
        return '?inIframe';
    };

    const getUrlWithQuery = (routePage:string | undefined, query:LocationQuery | undefined, fragmentIdentifier:string | undefined) => {
        if (modulesWithUrlParams.includes(routePage as string)) {
            return getParamUrn(query) + getUrlWithFragmentIdentifier(fragmentIdentifier);
        }
        if (modulesWithUrlQuery.includes(routePage as string)) {
            return generateSingleQuery(query, 'code') + getUrlWithFragmentIdentifier(fragmentIdentifier);
        }
        return getQueryUrn(query) + getUrlWithFragmentIdentifier(fragmentIdentifier);
    };

    const generateMfeUrl = (path: string) => {
        if (path.indexOf('/') === 0) {
            return `${IFRAME_URL}${path}`;
        }
        return `${IFRAME_URL}/${path}`;
    };

    return ({
        getUrlWithQuery,
        generateMfeUrl,
    });
};

export default { useManticoreNavigation };

export type ManticoreComponentProps = {
    iFrameUrl: string,
    query?: LocationQuery,
    openNewTab?: boolean,
    routePage?: string,
    param?: LocationQuery
}
